'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Summary = function (_BcReactComponent) {
  _inherits(Summary, _BcReactComponent);

  function Summary() {
    _classCallCheck(this, Summary);

    return _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).apply(this, arguments));
  }

  _createClass(Summary, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;

      return _react2.default.createElement(
        'svg',
        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-summary ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
        _react2.default.createElement('path', { className: 'path1', d: 'M11.445 0.055l-8.945 8.945-2.5 7 6.995-2.5 8.95-8.945c0.5-2-2.5-5-4.5-4.5zM4.5 11l-1-1 8.5-8.5 1 1-8.5 8.5z' })
      );
    }
  }]);

  return Summary;
}(_baseBcReactComponent2.default);

Summary.propTypes = {
  className: _react.PropTypes.string
};

exports.default = Summary;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Summary/Summary.js
// module id = 331
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15